var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6252 16.25C10.2814 16.25 10.0002 16.5312 10.0002 16.875V17.5C10.0002 18.1902 9.44044 18.75 8.75022 18.75H2.50034C1.81012 18.75 1.25037 18.1902 1.25037 17.5V7.5C1.25037 6.80977 1.81012 6.25 2.50034 6.25H6.87526C7.219 6.25 7.50024 5.96875 7.50024 5.625C7.50024 5.28125 7.219 5 6.87526 5H2.49995C1.11912 5 0 6.11914 0 7.5L0.000382805 17.5C0.000390617 18.8789 1.11951 20 2.50034 20H8.75022C10.1311 20 11.2502 18.8809 11.2502 17.5V16.875C11.2502 16.5312 10.9689 16.25 10.6252 16.25ZM19.6328 3.38398L16.6153 0.366406C16.3829 0.13168 16.0626 0 15.7306 0H11.2502C9.87129 0 8.75022 1.11914 8.75022 2.5V12.5C8.75022 13.8809 9.86934 15 11.2502 15H17.5C18.8809 15 20 13.8809 20 12.5V4.26953C20 3.9375 19.8672 3.61836 19.6328 3.38398ZM16.2501 1.76758L18.2305 3.75H16.2501V1.76758ZM18.75 12.5C18.75 13.1902 18.1903 13.75 17.5 13.75H11.2502C10.5599 13.75 10.0002 13.1902 10.0002 12.5V2.5C10.0002 1.80977 10.5599 1.25 11.2502 1.25H15.0001L15.0002 3.75C15.0002 4.44023 15.56 5 16.2502 5H18.75V12.5Z",
    fill: "#3ECF8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4110a1208b12750859f387e2cd792923.svg";
export { ForwardRef as ReactComponent };